// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-page {
  margin: 3rem 0.3rem 7rem 0.3rem;
}

body {
  background: #f5f5f5;
}

.container-contactPage {
  max-width: 1200px;
  margin: auto;
  padding: 0 15px;
}

.content-column {
  margin: auto;
}

/* Styling for the heading */
.get-in-touch-heading {
  color: black;
  font-size: 40px;
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  word-wrap: break-word;
  margin-bottom: 1rem;
}

.campaign-support-text {
  color: #3b3f3d;
  font-size: 19px;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  line-height: 26.6px;
  word-wrap: break-word;
  margin: 0 auto;
  margin-bottom: 1rem;
}

.contact-detail {
  color: #0a0f0d;
  font-size: 19px;
  font-family: "Roboto", sans-serif;
  font-weight: 600;
  line-height: 34.5px;
  word-wrap: break-word;
  margin-bottom: 1rem;
}

/* Specific styling for the email */
.contact-detail.email {
  text-decoration: underline;
}
a:hover {
  color: #d2042d;
}

.card-header {
  text-align: left;
  margin-bottom: 20px;
}

.card-header h2 {
  font-size: 28px;
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  color: black;
  margin-bottom: 10px;
}

.card-header p {
  font-size: 16px;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  color: black;
  line-height: 1.6;
}

.footer-text {
  text-align: center;
  margin-top: 20px;
  color: #5b5e5d;
  font-size: 14px;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
}

.contact-submit-btn {
  background: #d2042d;
  border-color: #d2042d;
  font-size: 19px;
  font-weight: 600;
  height: 50px;
}

.left-column {
  text-align: left;
}

.form-column {
  margin: 0 auto;
}

.customer-support {
  width: 100%;
  color: #0a0f0d;
  font-family: "Roboto", sans-serif;
}

.customer-supportDiv {
  margin-top: 4rem;
}

.support-heading {
  font-size: 19px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 10px;
  word-wrap: break-word;
}

.support-description {
  font-size: 16px;
  font-weight: 400;
  color: #3b3f3d;
  line-height: 1.5;
  word-wrap: break-word;
}

.contact-page-card-css {
  box-shadow: 2px 2px 30px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  padding: 10px 0px;
  margin: 0 auto;
}

/* Responsive Design */
@media (max-width: 575px) {
  .get-in-touch-heading {
    font-size: 24px;
    text-align: center;
    margin-bottom: 0.5rem;
  }

  .card-header h2 {
    font-size: 19px;
    color: black;
  }

  .campaign-support-text {
    font-size: 16px;
    line-height: 22px;
    text-align: justify;
  }
  .customer-supportDiv {
    margin-top: 2rem;
  }
  .contact-detail {
    font-size: 16px;
    line-height: 28px;
    text-align: center;
    color: #d2042d;
  }
  .customer-support {
    text-align: center;
    margin-bottom: 1.5rem;
  }

  .support-description {
    text-align: justify;
  }
}

@media (min-width: 576px) and (max-width: 767px) {
  .get-in-touch-heading {
    font-size: 36px;
  }

  .campaign-support-text {
    font-size: 18px;
    line-height: 24px;
  }

  .contact-detail {
    font-size: 18px;
    line-height: 32px;
  }

  .support-heading {
    font-size: 20px;
  }

  .support-description {
    font-size: 14px;
  }
}

@media (min-width: 768px) {
  .get-in-touch-heading {
    font-size: 20px;
  }

  .campaign-support-text {
    font-size: 14px;
    line-height: 24.6px;
  }

  .contact-detail {
    font-size: 19px;
    line-height: 34.5px;
  }

  .card-header h2 {
    font-size: 17px;
  }

  .card-header p {
    font-size: 14px;
  }

  .ant-btn-primary {
    font-size: 14px;
  }
  .contact-details-laptopView {
    display: block;
  }
}

.contact-details-laptopView {
  display: none;
}

.contact-details-MobileView {
  display: none;
}

@media (max-width: 768px) {
  .contact-page {
    margin: 4rem 0.3rem;
  }
}

@media (max-width: 767px) {
  .contact-details-MobileView {
    display: block;
  }
}

@media (max-width: 768px) {
  .small-screen-size {
    display: flex;
    flex-direction: column !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/contact/ContactPage.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;IACb,iCAAiC;EACnC;AACF","sourcesContent":[".contact-page {\n  margin: 3rem 0.3rem 7rem 0.3rem;\n}\n\nbody {\n  background: #f5f5f5;\n}\n\n.container-contactPage {\n  max-width: 1200px;\n  margin: auto;\n  padding: 0 15px;\n}\n\n.content-column {\n  margin: auto;\n}\n\n/* Styling for the heading */\n.get-in-touch-heading {\n  color: black;\n  font-size: 40px;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 700;\n  word-wrap: break-word;\n  margin-bottom: 1rem;\n}\n\n.campaign-support-text {\n  color: #3b3f3d;\n  font-size: 19px;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 400;\n  line-height: 26.6px;\n  word-wrap: break-word;\n  margin: 0 auto;\n  margin-bottom: 1rem;\n}\n\n.contact-detail {\n  color: #0a0f0d;\n  font-size: 19px;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 600;\n  line-height: 34.5px;\n  word-wrap: break-word;\n  margin-bottom: 1rem;\n}\n\n/* Specific styling for the email */\n.contact-detail.email {\n  text-decoration: underline;\n}\na:hover {\n  color: #d2042d;\n}\n\n.card-header {\n  text-align: left;\n  margin-bottom: 20px;\n}\n\n.card-header h2 {\n  font-size: 28px;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 700;\n  color: black;\n  margin-bottom: 10px;\n}\n\n.card-header p {\n  font-size: 16px;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 400;\n  color: black;\n  line-height: 1.6;\n}\n\n.footer-text {\n  text-align: center;\n  margin-top: 20px;\n  color: #5b5e5d;\n  font-size: 14px;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 400;\n}\n\n.contact-submit-btn {\n  background: #d2042d;\n  border-color: #d2042d;\n  font-size: 19px;\n  font-weight: 600;\n  height: 50px;\n}\n\n.left-column {\n  text-align: left;\n}\n\n.form-column {\n  margin: 0 auto;\n}\n\n.customer-support {\n  width: 100%;\n  color: #0a0f0d;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.customer-supportDiv {\n  margin-top: 4rem;\n}\n\n.support-heading {\n  font-size: 19px;\n  font-weight: 700;\n  line-height: 1.2;\n  margin-bottom: 10px;\n  word-wrap: break-word;\n}\n\n.support-description {\n  font-size: 16px;\n  font-weight: 400;\n  color: #3b3f3d;\n  line-height: 1.5;\n  word-wrap: break-word;\n}\n\n.contact-page-card-css {\n  box-shadow: 2px 2px 30px rgba(0, 0, 0, 0.05);\n  border-radius: 10px;\n  padding: 10px 0px;\n  margin: 0 auto;\n}\n\n/* Responsive Design */\n@media (max-width: 575px) {\n  .get-in-touch-heading {\n    font-size: 24px;\n    text-align: center;\n    margin-bottom: 0.5rem;\n  }\n\n  .card-header h2 {\n    font-size: 19px;\n    color: black;\n  }\n\n  .campaign-support-text {\n    font-size: 16px;\n    line-height: 22px;\n    text-align: justify;\n  }\n  .customer-supportDiv {\n    margin-top: 2rem;\n  }\n  .contact-detail {\n    font-size: 16px;\n    line-height: 28px;\n    text-align: center;\n    color: #d2042d;\n  }\n  .customer-support {\n    text-align: center;\n    margin-bottom: 1.5rem;\n  }\n\n  .support-description {\n    text-align: justify;\n  }\n}\n\n@media (min-width: 576px) and (max-width: 767px) {\n  .get-in-touch-heading {\n    font-size: 36px;\n  }\n\n  .campaign-support-text {\n    font-size: 18px;\n    line-height: 24px;\n  }\n\n  .contact-detail {\n    font-size: 18px;\n    line-height: 32px;\n  }\n\n  .support-heading {\n    font-size: 20px;\n  }\n\n  .support-description {\n    font-size: 14px;\n  }\n}\n\n@media (min-width: 768px) {\n  .get-in-touch-heading {\n    font-size: 20px;\n  }\n\n  .campaign-support-text {\n    font-size: 14px;\n    line-height: 24.6px;\n  }\n\n  .contact-detail {\n    font-size: 19px;\n    line-height: 34.5px;\n  }\n\n  .card-header h2 {\n    font-size: 17px;\n  }\n\n  .card-header p {\n    font-size: 14px;\n  }\n\n  .ant-btn-primary {\n    font-size: 14px;\n  }\n  .contact-details-laptopView {\n    display: block;\n  }\n}\n\n.contact-details-laptopView {\n  display: none;\n}\n\n.contact-details-MobileView {\n  display: none;\n}\n\n@media (max-width: 768px) {\n  .contact-page {\n    margin: 4rem 0.3rem;\n  }\n}\n\n@media (max-width: 767px) {\n  .contact-details-MobileView {\n    display: block;\n  }\n}\n\n@media (max-width: 768px) {\n  .small-screen-size {\n    display: flex;\n    flex-direction: column !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
